import { reportError } from '../../../monitoring/errorMonitor';
import React, { FC, useLayoutEffect, useRef } from 'react';

export interface QuickViewVideoProps {
  src: string;
  isLoadDeferred?: boolean;
  className?: string;
}

export const QuickViewVideo: FC<QuickViewVideoProps> = ({
  src,
  className,
  isLoadDeferred,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useLayoutEffect(() => {
    const video = videoRef.current;
    const handleVideoError = (event: Event) => {
      const target = event.target as HTMLVideoElement;
      const mediaError = target?.error;
      const attemptedUrl = target?.currentSrc || src;
      const errorDetails = {
        url: attemptedUrl,
        errorCode: mediaError?.code,
        errorMessage: mediaError?.message,
        component: 'QuickViewVideo',
      };
      console.error('[QuickViewVideo] Video load failed:', errorDetails);
      reportError(new Error(errorDetails.errorMessage || 'Video load failed'), {
        errorDetails,
      });
    };

    if (video) {
      video.addEventListener('error', handleVideoError);
    }

    return () => {
      if (video) {
        video.removeEventListener('error', handleVideoError);
      }
    };
  }, []);

  return (
    <video
      src={isLoadDeferred ? undefined : `${src}#t=0.1`}
      className={className}
      preload="metadata"
      ref={videoRef}
      muted
      autoPlay
      loop
      playsInline
    />
  );
};
